import { useLayoutEffect, useState, type RefObject } from 'react'

import { FIT_WIDTH_RATIO } from './constants'
import type { ImageSize } from './playback'

export const copyToCanvas = (target: HTMLCanvasElement, image: HTMLCanvasElement) => {
  target.width = image.width
  target.height = image.height
  target.getContext('2d')?.drawImage(image, 0, 0)
}

export const fittedSize = (image: ImageSize, box: ImageSize): ImageSize => {
  const scale = Math.min((box.width * FIT_WIDTH_RATIO) / image.width, box.height / image.height)
  return {
    width: Math.max(1, Math.round(image.width * scale)),
    height: Math.max(1, Math.round(image.height * scale)),
  }
}

export const useFittedSize = (image: ImageSize | null, container: RefObject<HTMLElement>): ImageSize | null => {
  const [size, setSize] = useState<ImageSize | null>(null)
  useLayoutEffect(() => {
    const node = container.current
    if (!image || !node) return
    const fit = () => setSize(fittedSize(image, { width: node.clientWidth, height: node.clientHeight }))
    fit()
    const observer = new ResizeObserver(fit)
    observer.observe(node)
    return () => observer.disconnect()
  }, [container, image])
  return size
}
